const SET_DATA_IMAGE = "SET_DATA_IMAGE";
const SET_IS_LOADING = "SET_IS_LOADING";
const SET_SEARCH_IMAGE = "SET_SEARCH_IMAGE";
const IMAGE_CONSTANT = {
	SET_DATA_IMAGE,
	SET_IS_LOADING,
	SET_SEARCH_IMAGE,
};

export default IMAGE_CONSTANT;
